(function ($, window) {
  
  const checkStockColors = () => {

    let colorOptions = $('.product-option__variant-btn--color[data-variant]').toArray();
    let colors = colorOptions.map(el => $(el).val());

    let selectedColorOption = $('.product-option__variant-btn--color[data-variant]:checked');
	let selectedColor = $(selectedColorOption).val();

    $.getJSON(`/products/${window.product_handle}.js`, (product) => {

      let { variants } = product;

      colorOptions.forEach(itemElement => {
        let color = $(itemElement).val();
        let filterAvailable = variants.filter(vItem => {
      
          if (vItem.options.indexOf(color) > -1) {
          //if (vItem.options.indexOf(selectedColor) > -1 && vItem.options.indexOf(color) > -1) {
            return true;
          }

          return false;
        });
      
        if (!filterAvailable.length) {
          $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).prop('disabled', true);
          $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).next('label').css('opacity', 0.4);
          $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).next('label').css('text-decoration', 'line-through');
        } else {
          if (filterAvailable[0].available) {
            $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).prop('disabled', false);
            $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).next('label').css('opacity', 1);
            $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).next('label').css('text-decoration', 'none');
          } else {
            //$(`.product-option__variant-btn--color[data-variant][value="${color}"]`).prop('disabled', true);
            $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).next('label').css('opacity', 0.4);
            $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).next('label').css('text-decoration', 'line-through');
          }
        }

        if ($(`.product-option__variant-btn--color[data-variant][value="${color}"]`).is(':disabled')) {
          $(`.product-option__variant-btn--color[data-variant][value="${color}"]`).prop('checked', false);

          if (selectedColor === color) {
            $(`.product-option__variant-btn--color[data-variant]:not([disabled]):first`).prop('checked', true);
          }
        }
      });

    });
  };
  
  const checkStock = () => {
    
    let sizeOptions = $('.product-option__variant-btn--size[data-variant]').toArray();
    let sizes = sizeOptions.map(el => $(el).val());
    let selectedSize = $('.product-option__variant-btn--size[data-variant]:checked');
    
    let colorOptions = $('.product-option__variant-btn--color[data-variant]').toArray();
    let colors = colorOptions.map(el => $(el).val());
    
    let selectedColorOption = $('.product-option__variant-btn--color[data-variant]:checked');
    let selectedColor = $(selectedColorOption).val();
    
    $.getJSON(`/products/${window.product_handle}.js`, (product) => {
    
      let { variants } = product;
      
      sizeOptions.forEach(itemElement => {
        let size = $(itemElement).val();
        let filterAvailable = variants.filter(vItem => {
          if (vItem.options.indexOf(selectedColor) > -1 && vItem.options.indexOf(size) > -1) {
            return true; 
          }
          
          return false;
        });
        
        if (!filterAvailable.length) {
          $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).prop('disabled', true);
          $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('opacity', 0.4);
          $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('text-decoration', 'line-through');
        } else {
          if (filterAvailable[0].available) {
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).prop('disabled', false);
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('opacity', 1);
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('text-decoration', 'none');
          } else {
          //  $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).prop('disabled', true);
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('opacity', 0.4);
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('text-decoration', 'line-through');
          }
        }
       
        if ($(`.product-option__variant-btn--size[data-variant][value="${size}"]`).is(':disabled')) {
          $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).prop('checked', false);
          
          if (selectedSize.val() === size) {
            $(`.product-option__variant-btn--size[data-variant]:not([disabled]):first`).prop('checked', true);
          }
        }
        
      });

    });
  };
  
  const checkStockSizes = () => {
    
    let sizeOptions = $('.product-option__variant-btn--size[data-variant]').toArray();
    let sizes = sizeOptions.map(el => $(el).val());
    let selectedSize = $('.product-option__variant-btn--size[data-variant]:checked');
    
    $.getJSON(`/products/${window.product_handle}.js`, (product) => {
    
      let { variants } = product;
      
      sizeOptions.forEach(itemElement => {
        let size = $(itemElement).val();
        let filterAvailable = variants.filter(vItem => {
          if (vItem.options.indexOf(size) > -1) {
            return true; 
          }
          
          return false;
        });
        
        if (!filterAvailable.length) {
          $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).prop('disabled', true);
          $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('opacity', 0.4);
          $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('text-decoration', 'line-through');
        } else {
          if (filterAvailable[0].available) {
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).prop('disabled', false);
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('opacity', 1);
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('text-decoration', 'none');
          } else {
           // $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).prop('disabled', true);
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('opacity', 0.4);
            $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).next('label').css('text-decoration', 'line-through');
          }
        }
        
        if ($(`.product-option__variant-btn--size[data-variant][value="${size}"]`).is(':disabled')) {
          $(`.product-option__variant-btn--size[data-variant][value="${size}"]`).prop('checked', false);
          
          if (selectedSize.val() === size) {
            $(`.product-option__variant-btn--size[data-variant]:not([disabled]):first`).prop('checked', true);
          }
        }
      });

    });
  };

  $(document).ready(() => {
                    
    if ($('.product-option__variant-btn--color[data-variant]').length && $('.product-option__variant-btn--size[data-variant]').length) {
      $('.product-option__variant-btn--color[data-variant]').on('change', () => checkStock());
      checkStock();   
  	} else if ($('.product-option__variant-btn--size[data-variant]').length) {
   	  checkStockSizes();
  	} else if ($('.product-option__variant-btn--color[data-variant]').length) {
   	  checkStockColors();
  	}
            
          size_select();
            $('.product-option__variant-btn--color[data-variant]').on('change',function(){
              size_select();
            });
            function size_select()
            {
              if(!$('.product-option__variant-btn--size[data-variant]').is(":checked")){
            	$('.product-option__variant-btn--size[data-variant]:not(:disabled):first').prop("checked", true).trigger('click');

                }
            }
  });
  
})(jQuery, window);